import jQuery from "../modules/jquery/jquery-3.6.1.min.js"

jQuery(document).ready(function($) {
    $('#categories, #tags').on('change', function () {
        var url = $(this).val();
        if (url) {
            if (url == 'all') {
                window.location = $(this).data('default');
            } else {
                window.location = url;
            }
        }
        return false;
    });

    // Content Table Functionality
    let links = $('.blog-anchors').data('links');
    if( $('.article-content').find('h1, h2, h3').length < 1) {
        $('.blog-anchors').remove();
    }

    if (!links) { links = 3; }
    $('.blog-anchors').append('<ul></ul>');
    var i = 1;
    $('.article-content').find('h1, h2, h3').each(function(index) {
        i++;
        var header_text = $(this).text().replace(/[^a-zA-Z0-9 ]/g, "");
        var header_anchor = "anchor-" + i;
        $(this).addClass('anchor').attr("id", header_anchor);
        if (i <= links) {
            $('.blog-anchors ul').append('<li class="' + header_anchor + '" style="display: block"><a href="#' + header_anchor + '">' + header_text + '</a></li>');
        }else {
            $('.blog-anchors ul').append('<li class="' + header_anchor + '"><a href="#' + header_anchor + '">' + header_text + '</a></li>');
        }
    });
    if (i > links) {
        $('.blog-anchors ul').append('<li class="anchor-more" style="display: block"><a href="#">&plus; More</a></li><li class="anchor-less"><a href="#">&minus; Less</a></li>');
    }

    $('.anchor-more').click(function(event) {
        event.preventDefault();
        $(this).hide();
        $(this).parent().addClass('show-all');
        $(this).parent().find('.anchor-less').show();
    });

    $('.anchor-less').click(function(event) {
        event.preventDefault();
        $(this).hide();
        $(this).parent().removeClass('show-all');
        $(this).parent().find('.anchor-more').show();
    });

    $(window).scroll(function() {
        $('.anchor').each(function(){
            var anchor = $(this); 
            var anchor_name = anchor.attr('id');
            if (anchor.offset().top < $(window).scrollTop() + 10) {
                $('.blog-anchors .' + anchor_name).addClass('read');
            } else {
                $('.blog-anchors .' + anchor_name).removeClass('read');
            }
        });
    });
});